import { type ReactNode } from 'react';
import { HStack, Text } from '@direct-frontend/components';
import { type OrderLoyalty } from '@/shared/api/order';
import IconLock from '@/shared/assets/IconLock.react.svg';
import { formatBonusWithCount } from '@/shared/lib/bonus';
import { modalsService } from '@/shared/lib/modalsService';
import { getRequestContext } from '@/shared/lib/requestContext';

interface PaymentInformerCashbackRowProps {
    bonuses: number;
    addonLeft?: ReactNode;
}

export const PaymentInformerCashbackRow = (props: PaymentInformerCashbackRowProps) => {
    const { bonuses, addonLeft } = props;

    const pluralizedBonuses = formatBonusWithCount(bonuses);

    return (
        <HStack justifyContent="space-between">
            <Text size="s">Кешбэк</Text>

            <HStack gap="4">
                {addonLeft}

                <Text size="s">+ {pluralizedBonuses}</Text>
            </HStack>
        </HStack>
    );
};

interface PaymentInformerCashbackProps {
    loyalty?: OrderLoyalty;
}

export const PaymentInformerCashback = (props: PaymentInformerCashbackProps) => {
    const {
        account: { loggedIn },
    } = getRequestContext();
    const { loyalty } = props;

    if (!loyalty) {
        return null;
    }

    if (loyalty.is_registered_user && loyalty.registered_user_loyalty.bonuses_will_return) {
        return <PaymentInformerCashbackRow bonuses={loyalty.registered_user_loyalty.bonuses_will_return} />;
    }

    if (!loyalty.is_registered_user && loyalty.unregistered_user_loyalty.potential_bonuses) {
        return (
            <PaymentInformerCashbackRow
                bonuses={loyalty.unregistered_user_loyalty.potential_bonuses}
                addonLeft={
                    <IconLock
                        cursor="pointer"
                        onClick={() => {
                            loggedIn
                                ? modalsService.onLoyaltyRegister('bonus-program')
                                : modalsService.onLoyaltyPromo();
                        }}
                    />
                }
            />
        );
    }

    return null;
};
